<template>
  <div
    v-if="friend"
    @click="remove ? emitRemove : checkbox ? emitInput() : openProfile()"
    :class="{
      'bg-gray-200': disabled && !selected,
      'bg-gray-200 pl-5': selected,
      'opacity-50': pending || isFriendRequest,
    }"
    class="grid grid-cols-auto-1-auto col-gap-2 p-3 items-center hover:shadow hover:pl-5 cursor-pointer transition-all duration-100"
  >
    <div class="w-12 h-12">
      <avatar :avatar="friend.avatar" />
    </div>
    <div class="w-full overflow-hidden pointer-events-none" v-if="!loading">
      <div
        v-if="friend.username"
        class="font-medium leading-tight tracking-wide"
      >
        {{ friend.username }}
      </div>
      <div class="text-sm italic" v-if="isFriendRequest">
        {{ $t("users.friend_request") }}
      </div>
      <div class="text-sm italic" v-if="pending">
        {{ $t("general.pending") }}
      </div>
    </div>
    <loading v-else />
    <div v-if="checkbox">
      <icon name="Checkbox" :settings="{ active: selected }" />
    </div>
    <div v-else-if="isFriendRequest">
      <wd-button transparent @input="respondRequest(false)">
        <span class="text-red-500">
          <icon name="Reject" size="1.3em" />
        </span>
      </wd-button>
      <wd-button transparent @input="respondRequest(true)">
        <span class="ml-2 text-green-500">
          <icon name="Accept" size="1.3em" />
        </span>
      </wd-button>
    </div>
  </div>
</template>

<script>
const Avatar = require("@/modules/avatars/components/Avatar.vue").default;

import { UserFriendRequest } from "@/modules/users/viewmodels/UserFriendRequest";

export default {
  name: "Friend",
  data() {
    return {
      lastMessages: null,
      selected: false,
      loading: true,
      isFriendRequest: false,
    };
  },
  props: {
    friend: {
      default: null,
      type: Object,
    },
    checkbox: {
      default: false,
      type: Boolean,
    },
    checked: {
      default: false,
      type: Boolean,
    },
    remove: {
      default: false,
      type: Boolean,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
    pending: {
      default: false,
      type: Boolean,
    },
    friendRequest: {
      default: null,
      type: UserFriendRequest,
    },
  },
  components: {
    Avatar,
  },
  methods: {
    openProfile() {
      this.$router.push("/profile/" + this.friend.id);
    },
    emitInput(Bool) {
      this.selected = typeof Bool === "boolean" ? Bool : !this.selected;
      let payload = { friend: this.friend, checked: this.selected };
      this.$emit("input", payload);
    },
    async respondRequest(Bool) {
      if (Bool === true) {
        this.$store.getters["userfriendrequest/api"].Custom.Accept(
          this.friendRequest.id
        ).then((e) => {
          this.$store.dispatch(
            "userfriendrequest/removeIncomingFriendRequest",
            this.friendRequest.id
          );
          this.$store.getters["userfriend/api"].Custom.My();
        });
      } else {
        this.$store.getters["userfriendrequest/api"].Custom.Reject(
          this.friendRequest.id
        ).then((e) => {
          this.$store.dispatch(
            "userfriendrequest/removeIncomingFriendRequest",
            this.friendRequest.id
          );
        });
      }
    },
  },
  computed: {},
  created() {
    if (this.checked) {
      this.selected = this.checked;
      this.emitInput(true);
    }
    this.isFriendRequest = this.friendRequest !== null;
  },
  async mounted() {
    this.loading = false;
  },
};
</script>
